var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconWheel = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4001_50)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.125 16.5C4.125 18.1251 4.44509 19.7343 5.06699 21.2357C5.68889 22.7371 6.60043 24.1013 7.74955 25.2504C8.89868 26.3996 10.2629 27.3111 11.7643 27.933C13.2657 28.5549 14.8749 28.875 16.5 28.875C18.1251 28.875 19.7343 28.5549 21.2357 27.933C22.7371 27.3111 24.1013 26.3996 25.2504 25.2504C26.3996 24.1013 27.3111 22.7371 27.933 21.2357C28.5549 19.7343 28.875 18.1251 28.875 16.5C28.875 14.8749 28.5549 13.2657 27.933 11.7643C27.3111 10.2629 26.3996 8.89868 25.2504 7.74955C24.1013 6.60043 22.7371 5.68889 21.2357 5.06699C19.7343 4.44509 18.1251 4.125 16.5 4.125C14.8749 4.125 13.2657 4.44509 11.7643 5.06699C10.2629 5.68889 8.89868 6.60043 7.74955 7.74955C6.60043 8.89868 5.68889 10.2629 5.06699 11.7643C4.44509 13.2657 4.125 14.8749 4.125 16.5Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.75 16.5C13.75 17.2293 14.0397 17.9288 14.5555 18.4445C15.0712 18.9603 15.7707 19.25 16.5 19.25C17.2293 19.25 17.9288 18.9603 18.4445 18.4445C18.9603 17.9288 19.25 17.2293 19.25 16.5C19.25 15.7707 18.9603 15.0712 18.4445 14.5555C17.9288 14.0397 17.2293 13.75 16.5 13.75C15.7707 13.75 15.0712 14.0397 14.5555 14.5555C14.0397 15.0712 13.75 15.7707 13.75 16.5Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 19.25V28.875",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.75 16.5L4.46875 13.75",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.25 16.5L28.5312 13.75",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4001_50"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconWheel, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_wheel.522c168d.svg";
export { ForwardRef as ReactComponent };